import React from "react";

import Button from "../../Components/UI/Button/Button";

import * as actionTypes from "./actionTypes";

const initialState = {
  loading: false,
  invoicesDetails: {
    dataSource: null,
    columns: [],
    headers: "",
    totalCars: 0
  },
  openedDropdownRowId: null,
  searchText: "",
  invoiceStatus: "",
  invoiceDate: [],
  invoiceEmail: "",
  expandedRowDetails: {
    loading: false,
    dataSource: [],
    columns: []
  },
  pagination: { pageSize: 20, currentPage: 1 }
};

const fetchInvoicesStart = (state) => ({
  ...state,
  loading: true
});

const fetchInvoicesSuccess = (state, action) => ({
  ...state,
  totalCars: action.data.totalCars,
  loading: false,
  invoicesDetails: {
    dataSource: action.data.dataSource,
    columns: action.data.columns,
    totalCars: action.data.totalCars
  },
  pagination: {
    ...state.pagination,
    pageSize: action.data.pageSize
  }
});

const fetchInvoicesFail = (state) => ({
  ...state,
  loading: false
});

const fetchDropdrownStart = (state) => ({
  ...state,
  expandedRowDetails: {
    ...state.expandedRowDetails,
    loading: true
  }
});
const fetchDropdrownSuccess = (state, action) => ({
  ...state,
  expandedRowDetails: {
    ...state.expandedRowDetails,
    dataSource: action.data.dataSource,
    column: action.data.columns.map((column) => {
      if (column.title === "ETA") {
        return {
          ...column,
          render: (_, record) => (
            <div>
              {record.eta ? (
                <Button type="primary" variant="xSmall" color={record.eta?.template?.toLowerCase()}>
                  {record.eta?.title}
                </Button>
              ) : null}
            </div>
          )
        };
      }
      return column;
    }),
    loading: false
  }
});
const fetchDropdrownFail = (state) => ({
  ...state,
  expandedRowDetails: {
    ...state.expandedRowDetails,
    loading: false
  }
});

const setCurrentPage = (state, action) => ({
  ...state,
  pagination: {
    ...state.pagination,
    currentPage: action.data
  }
});

const setPageSize = (state, action) => {
  const {
    invoicesDetails: { totalCars },
    pagination: { currentPage }
  } = state;
  const lastPage = totalCars / action.data;

  return {
    ...state,
    pagination: {
      ...state.pagination,
      pageSize: action.data,
      currentPage: lastPage > currentPage ? currentPage : Math.ceil(lastPage)
    }
  };
};

const setSearchText = (state, action) => ({
  ...state,
  searchText: action.text,
  pagination: {
    ...state.pagination,
    currentPage: 1
  }
});

const setInvoicesDropdownId = (state, action) => ({
  ...state,
  openedDropdownRowId: action.id
});

const setInvoiceStatus = (state, action) => ({
  ...state,
  invoiceStatus: action.status,
  pagination: {
    ...state.pagination,
    currentPage: 1
  }
});

const setInvoiceDate = (state, action) => ({
  ...state,
  invoiceDate: action.date?.length > 0 ? action.date : [],
  pagination: {
    ...state.pagination,
    currentPage: 1
  }
});

const setInvoiceEmail = (state, action) => ({
  ...state,
  invoiceEmail: action.email,
  pagination: {
    ...state.pagination,
    currentPage: 1
  }
});

const resetInvoice = () => initialState;

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_INVOICES_DATA_START:
      return fetchInvoicesStart(state, action);
    case actionTypes.FETCH_INVOICES_DATA_SUCCESS:
      return fetchInvoicesSuccess(state, action);
    case actionTypes.FETCH_INVOICES_DATA_FAIL:
      return fetchInvoicesFail(state, action);
    case actionTypes.FETCH_INVOICES_DROPDOWN_START:
      return fetchDropdrownStart(state, action);
    case actionTypes.FETCH_INVOICES_DROPDOWN_SUCCESS:
      return fetchDropdrownSuccess(state, action);
    case actionTypes.FETCH_INVOICES_DROPDOWN_FAIL:
      return fetchDropdrownFail(state, action);
    case actionTypes.SET_INVOICE_CURRENT_PAGE:
      return setCurrentPage(state, action);
    case actionTypes.SET_INVOICE_PAGE_SIZE:
      return setPageSize(state, action);
    case actionTypes.SET_INVOICES_SEARCH_INPUT:
      return setSearchText(state, action);
    case actionTypes.SET_INVOICES_DROPDOWN_ID:
      return setInvoicesDropdownId(state, action);
    case actionTypes.RESET_INVOICE:
      return resetInvoice();
    case actionTypes.SET_INVOICE_STATUS:
      return setInvoiceStatus(state, action);
    case actionTypes.SET_INVOICE_DATE:
      return setInvoiceDate(state, action);
    case actionTypes.SET_USER_EMAIL:
      return setInvoiceEmail(state, action);
    default:
      return state;
  }
};

export default reducer;
